export default __webpack_public_path__ + "static/onboarding1-759ada9f32fbfc15c94b0547ae11a84c.webp";